import { ApiResponse, ApiResponseObject } from '@interfaces/api-response/1.0';

export enum POSProviderType {
  RestaurantIntegration = 'RestaurantIntegration',
  POS_SPI = 'POS_SPI',
}

export interface POSIntegrationConfiguration {
  id: string;
  displayName: string;
  posProviderType: POSProviderType;
  description?: string;
  versionId?: string;
  priceOverride?: string;
}

export interface POSIntegrationsResponse extends ApiResponse {
  _embedded: {
    PosIntegrationConfigurations: POSIntegrationConfiguration[];
  };
}

export interface CopyPosConfigDialogData {
  childStoreId: string;
  copiedFromTenantId: string;
  copiedFromStoreId: string;
}
